
import '~/assets/scss/index.scss'

import OrderListCmp from '@/components/cs/or/OrderListCmp.vue' // 마이페이지 주문 목록
import { commonfunc } from '~/mixin/common'
import { csMixin } from '~/mixin/cs/csMixin'

import NoData from '@/components/common/template/NoData.vue'

export default {
  name: 'SCH0001',
  components: {
    OrderListCmp,
    NoData
  },
  mixins: [commonfunc, csMixin],
  layout: 'DsMainLayout',
  data () {
    return {
      searchInput: '', // 검색 input
      orderList: [],
      form: {
        currentPage: 1,
        pageSize: 5,
        mbMngNo: this.$store.getters['session/getMbMngNo'], // 'MB102023090685154817',
        strtDt: '',
        endDt: ''
      }
    }
  },
  head () {
    return {
      title: '고객센터 : 다이소몰',
      meta: [
        { hid: 'og:title', property: 'og:title', content: '고객센터 : 다이소몰' },
        { hid: 'og:url', property: 'og:url', content: window.location.href }
      ],
    }
  },
  beforeMount () {
    console.log(this.$route.query.ntmtNo)
  },
  mounted () {
    this.lodeMore()
  },
  methods: {
    lodeMore (type) {
      if (type === 'more') {
        this.form.currentPage += 1
      } else {
        this.form.currentPage = 1
      }

      const now = new Date()
      const end = this.toStringByFormatting(now, '')
      this.form.strtDt = this.toStringByFormatting(new Date(now.setMonth(now.getMonth() - 3)), '')
      this.form.endDt = end

      this.$AxiosBuilder
        .data(this.form)
        .build()
        .post('/or/orb/selOr')
        .then((res) => {
          console.log(res)
          if (res.data.data.length > 0) {
            const list = res.data.data
            this.total = list[0].totalCnt ?? ''
            list.forEach((element) => {
              // 주문상태값 보여주기
              const flag = []
              flag.push({ cd: '01', nm: element.orStsCdNm })
              element.flag = flag

              switch (true) {
                case element.orTyCd === '01' && element.dlvFomCd === '01': element.orTyCdNm = '택배배송'
                  break
                case element.orTyCd === '01' && element.dlvFomCd === '02': element.orTyCdNm = '매장픽업'
                  break
                case element.orTyCd === '02' && element.dlvFomCd: element.orTyCdNm = '정기배송'
                  break
                case element.orTyCd === '03': element.orTyCdNm = '대량주문'
                  break
                case element.gfYn === 'Y': element.orTyCdNm = '상품권'
                  break
                default:
                  break
              }
              // 주문일자, 주문유형 보여주기
              element.branch = {
                date: this.dateYYYYMMDDFormatterCommaStr(element.orderProd[0].orDt),
                place: element.orTyCdNm
              }
              let orStsDate = ''
              // 배송준비중 ,배송중일때 배송예정일자 + ~"도착예정" 표시
              if (element.orStsCd === '40' || element.orStsCd === '41') {
                orStsDate = element.orderProd.reduce((late, current) => {
                  if (current.dlvParmDt && (current.dlvParmDt < late.dlvParmDt)) {
                    return current
                  } else {
                    return late
                  }
                }, element.orderProd[0].dlvParmDt)
                if (orStsDate !== null && orStsDate !== undefined && orStsDate !== '') {
                  element.delryWhether = {
                    date: this.dateYYYYMMDDFormatterCommaStr(orStsDate) + '(' + this.toJsWeekDay(orStsDate) + ')',
                    whether: true
                  }
                }
              } else {
                // 배송완료 일 때 배송완료일시 표시
                if (element.orStsCd === '45') {
                  orStsDate = element.orderProd.reduce((late, current) => {
                    if (current.dlvCmptDtm && (current.dlvCmptDtm < late.dlvCmptDtm)) {
                      return current
                    } else {
                      return late
                    }
                  }, element.orderProd[0].dlvCmptDtm)
                  if (orStsDate !== null && orStsDate !== undefined && orStsDate !== '') {
                    orStsDate = this.format(orStsDate, 'YYYY.MM.DD')
                  }
                // 결제대기
                } else if (element.orStsCd === '20' && this.isExist(element.vrtAcunDpsDdlnDtm)) {
                  orStsDate = this.format(element.vrtAcunDpsDdlnDtm, 'YYYY.MM.DD') + ' 까지'
                // 결제완료
                } else if (element.orStsCd === '21' && this.isExist(element.pyCmptDtm)) {
                  // orStsDate = this.format(element.pyCmptDtm, 'YYYY.MM.DD')
                // 픽업대기
                } else if (element.orStsCd === '51' && this.isExist(element.pkupWaitDtm)) {
                  orStsDate = this.format(element.pkupWaitDtm, 'YYYY.MM.DD') + ' 까지'
                // 픽업완료
                } else if (element.orStsCd === '55' && this.isExist(element.pkupCmptDtm)) {
                  orStsDate = this.format(element.pkupCmptDtm, 'YYYY.MM.DD')
                // 주문 취소
                } else if (element.orStsCd === '70' && this.isExist(element.orCnclDtm)) {
                  // orStsDate = this.format(element.orCnclDtm, 'YYYY.MM.DD')
                }
                // if (!orStsDate) {
                //   orStsDate = ''
                // } else {
                //   const dateObject = new Date(orStsDate)
                //   const year = dateObject.getFullYear()
                //   const month = (dateObject.getMonth() + 1).toString().padStart(2, '0') // 월은 0부터 시작하므로 1을 더하고 두 자리로 포맷팅
                //   const day = dateObject.getDate().toString().padStart(2, '0') // 일자를 두 자리로 포맷팅
                //
                //   const formattedDate = `${year}-${month}-${day}`
                //
                //   orStsDate = formattedDate
                // }

                if (!orStsDate) {
                  orStsDate = ''
                } else {
                  element.delryWhether = {
                    date: orStsDate
                  }
                }
              }

              // orBaseJson 셋팅
              element.orBaseJson = {
                orDtlStsCd: element.orderProd[0].orDtlStsCd,
                dlvFomCd: element.orderProd[0].dlvFomCd,
                orTyCd: element.orTyCd,
                orNo: element.orNo
              }

              // 주문 상세보기 이동 셋팅
              element.detailLink = {
                url: this.orDetailShowSeperate(element.orTyCd, element.orderProd[0].dlvFomCd, element.gfYn),
                orNo: element.orNo,
                text: '주문 상세보기'
              }
              // 상품 리스트 데이터 셋팅
              const rand = element.orTyCd
              element.orderProd.forEach((element) => {
                element.name = element.exhPdNm
                element.thumb = this.isNotEmpty(element.pdImgUrl) ? process.env.CDN_BASE_URL + element.pdImgUrl : '/images/content/noimage.png'
                element.id = element.orNo
                element.price = this.numberWithCommas(element.orAm)
                element.totalPdPrice = this.numberWithCommas(parseInt(element.orAm * element.orQy))
                element.reviewScore = element.stscVal
                element.orderDate = this.dateYYYYMMDDFormatterCommaStr(element.orDt)
                element.buying = element.orQy
                element.soldOut = false
                element.review = {
                  buyDay: 17, // todo
                  link: '#',
                  cash: '100' // todo
                }
                // element
                // 굿즈 여부 체크
                if (element.pdTy === '04') { // 04 == goods
                  element.goods = true
                } else {
                  element.goods = false
                }
                // 옵션 체크
                if (rand === '03' && element.optPdYn === 'Y') {
                  element.option = 'random'
                } else if (element.optPdYn === 'Y') {
                  element.option = element.optCn
                } else {
                  element.option = ''
                }
              })
            })
            if (type === 'more') {
              this.orderList.push(...list)
            } else {
              this.orderList = list
            }
          } else {
            this.form.currentPage = this.form.currentPage > 1 ? this.form.currentPage - 1 : 1
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    prodUnitClick ({ orNo, pdNo, item }) {
      console.log('sch0001')
      console.log('orNo:: ' + orNo + 'pdNo:: ' + pdNo)
      const or = JSON.parse(JSON.stringify(this.orderList.find(element => element.orNo === orNo)))
      const pd = or.orderProd.find(element => element.orSeq === item.orSeq)
      const pdArr = []
      pdArr.push(pd)
      or.orderProd = pdArr
      // this.$router.push({ name: 'cs-csh-SCR_CSH_0002', params: { prodItem: JSON.stringify(or) } })
      this.$emit('callback-event', JSON.stringify(or))
    },
    srchWord () {
      if (this.searchInput === null || this.searchInput === '' || this.searchInput.length < 1) {
        this.$alert('검색어를 입력해주세요')
        return
      }
      const path = '/cs/csi/SCR_CSI_0001'
      this.$router.push({ path, query: { type: 'txt', param: this.searchInput } })
    },
    goFaq (param) {
      const path = '/cs/csi/SCR_CSI_0001'
      if (param === 'all') {
        this.$router.push({ path })
      } else {
        this.$router.push({ path, query: { type: 'tab2', param } })
      }
    },
    leftPad (value) {
      if (value >= 10) {
        return value
      }

      return `0${value}`
    },
    toStringByFormatting (source, delimiter) {
      const year = source.getFullYear()
      const month = this.leftPad(source.getMonth() + 1, 2, '0')
      const day = this.leftPad(source.getDate(), 2, '0')

      return [year, month, day].join(delimiter)
    },
    orDetailShowSeperate (orTyCd, dlvFomCd, gfYn) {
      let url = ''
      // 일반주문 택배배송
      if (orTyCd === '01' && dlvFomCd === '01') {
        url = '/or/orb/SCR_ORB_0002'
        // 일반주문 매장픽업
      } else if (orTyCd === '01' && dlvFomCd === '02') {
        url = '/or/orb/SCR_ORB_0002'
        // 정기주문 택배배송
      } else if (orTyCd === '02' && dlvFomCd === '01') {
        url = '/or/orb/SCR_ORB_0003'
        // 대량주문 용차배송
      } else if (orTyCd === '03' && dlvFomCd === '03') {
        url = '/or/orb/SCR_ORB_0006'
        // 대량주문 매장픽업
      } else if (orTyCd === '03' && dlvFomCd === '02') {
        url = '/or/orb/SCR_ORB_0006'
        // 상품권
      } else if (orTyCd === '01' && gfYn === 'Y') {
        url = '/or/orb/SCR_ORB_0004'
      }
      return url
    }
  }
}
